// ------------------------------------------------------------------
// TNV international partner network.
// These people are PARTNERS, not employees — designations must stay
// exactly as agreed. Do not add qualifications, employers or figures
// that have not been verified.
// ------------------------------------------------------------------

export const PARTNERS = [
  {
    id: "ali-khan",
    name: "Ali Khan",
    first: "Ali",
    role: "Founder & CEO | EU & Saudi Arabia Business Development & Commercial",
    location: "Sweden | Portugal | EU & Saudi Arabia",
    email: "ali@thenordicvision.com",
    phone: "+46 72 765 61 33",
    whatsapp: "46727656133",
    photo: "/assets/partners/ali.webp",
    intro: "Ali Khan is the Founder & CEO of The Nordic Vision, leading the company's strategic direction, commercial development and international market expansion. Based in Portugal, Ali focuses on developing business opportunities across Europe and Saudi Arabia and building long-term relationships with clients, contractors and strategic partners.",
    achievements: [
      "International HSE and workforce-sector experience",
      "Business development and commercial activities across European and Saudi Arabian markets",
      "Experience of industrial, construction, manufacturing and infrastructure environments",
      "Development of workforce and professional service solutions",
    ],
    focus: ["Company Leadership", "EU & Saudi Arabia Business Development", "Client Acquisition", "Strategic Accounts"],
    departments: ["business", "operations"],
    flag: "pt",
    flags: ["se", "pt"],
    coords: [-8.2, 39.5],
  },
  {
    id: "david-azor",
    name: "David Azor",
    first: "David",
    role: "UK & Global Workforce Partnerships Partner",
    location: "United Kingdom | Portugal",
    email: "david@thenordicvision.com",
    phone: "+44 7774 924524",
    whatsapp: "447774924524",
    photo: "/assets/partners/david.webp",
    intro: "David Azor supports The Nordic Vision's international growth through UK market development, strategic partnerships and international workforce networks. His role focuses on building relationships with businesses, contractors and professional networks that support TNV's workforce and industrial-services activities.",
    achievements: [
      "Experience across HSE / SHEQ environments",
      "Construction, industrial and data centre project environments",
      "Manufacturing and major international project exposure",
      "Workforce and professional services partnerships",
    ],
    focus: ["UK Market", "Commercial Strategy", "Strategic Partnerships", "International Workforce Networks"],
    departments: ["business", "manpower"],
    flag: "gb",
    flags: ["gb", "pt"],
    coords: [-2.0, 53.5],
  },
  {
    id: "pawel-piatek",
    name: "Paweł Piątek",
    first: "Paweł",
    role: "EU Workforce & HSE Solutions Partner",
    location: "Poland | Portugal",
    email: "pawel@thenordicvision.com",
    phone: "+48 660 459 630",
    whatsapp: "48660459630",
    photo: "/assets/partners/pawel.webp",
    intro: "Paweł Piątek supports The Nordic Vision's European workforce and HSE solutions, with a focus on recruitment networks, skilled workforce sourcing and connecting qualified professionals with client requirements across European markets.",
    achievements: [
      "Workforce sourcing across European markets",
      "Recruitment of skilled manpower for construction and industry",
      "HSE-related workforce activities",
    ],
    focus: ["EU Workforce", "Recruitment", "HSE Professionals", "Skilled Workforce"],
    departments: ["recruitment", "hse"],
    flag: "pl",
    flags: ["pl", "pt"],
    coords: [19.1, 52.1],
  },
  {
    id: "igor-czajor",
    name: "Igor Czajor",
    first: "Igor",
    role: "Nordic Workforce & Operations Partner",
    location: "Poland | Nordic Region | Portugal",
    email: "igor@thenordicvision.com",
    phone: "+48 508 126 197",
    whatsapp: "48508126197",
    photo: "/assets/partners/igor.webp",
    intro: "Igor Czajor supports The Nordic Vision's Nordic workforce and operational activities, focusing on workforce mobilisation, project coordination, operational support and client coordination across the Nordic region.",
    achievements: [
      "Workforce mobilisation for project starts",
      "Project coordination and operational support",
      "Industrial and construction site environments",
      "Client coordination across Nordic markets",
    ],
    focus: ["Nordic Markets", "Workforce Mobilisation", "Project Operations", "Client Coordination"],
    departments: ["operations", "manpower"],
    flag: "pl",
    flags: ["pl", "pt"],
    coords: [15.6, 58.0],
  },
];

export const partnersForDepartment = (id) => PARTNERS.filter((p) => (p.departments || []).includes(id));

export const VALUES = [  { id: "people-first", icon: "Users", title: "People First", text: "We value the people behind every project and every successful delivery." },
  { id: "quality", icon: "BadgeCheck", title: "Quality", text: "We focus on qualified people, reliable service and professional delivery." },
  { id: "integrity", icon: "Scale", title: "Integrity", text: "We build relationships through transparency, accountability and trust." },
  { id: "partnership", icon: "Handshake", title: "Partnership", text: "We aim to build long-term relationships rather than short-term transactions." },
  { id: "safety", icon: "ShieldCheck", title: "Safety", text: "Safety and responsible working practices remain central to the way we operate." },
];
